import React from "react";
import { Plus, X, Info } from "lucide-react";
import { Input } from "@/components/ui/input";
import { fmtEUR2 } from "@/lib/format";

export const MODES = [
  { k: "cb", l: "CB" }, { k: "especes", l: "Espèces" }, { k: "cheque", l: "Chèque" },
  { k: "secu", l: "Sécurité sociale / CMU" }, { k: "mutuelle", l: "Mutuelle" }, { k: "alma", l: "Alma" },
];
export const newPatient = () => ({ id: `tmp-${Math.random().toString(36).slice(2, 10)}`, patient: "", mutuelle_name: "", cb: "", especes: "", cheque: "", secu: "", mutuelle: "", alma: "" });
export const rowTotal = (p) => MODES.reduce((s, m) => s + (parseFloat(p[m.k]) || 0), 0);
export const sumMode = (rows, k) => rows.reduce((s, p) => s + (parseFloat(p[k]) || 0), 0);

const GRID = "sm:grid-cols-[minmax(150px,2fr)_repeat(6,minmax(68px,1fr))_80px_28px]";

export function PatientTable({ rows, onChange }) {
  const upd = (i, k, v) => onChange(rows.map((p, j) => (j === i ? { ...p, [k]: v } : p)));
  return (
    <div className="rounded-2xl border border-gray-100 p-3" data-testid="daily-patients">
      <p data-testid="daily-patient-name-hint" className="mb-3 flex items-start gap-2 rounded-xl bg-amber-50 px-3 py-2 text-xs text-amber-800">
        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        <span>Saisissez le <strong>nom et le prénom complets</strong> du patient, tels qu'ils figurent sur sa carte Vitale (ex. : RACINE Elsa). C'est indispensable pour le rapprochement automatique avec les relevés Sécurité sociale et mutuelles.</span>
      </p>
      <div className={`hidden gap-2 px-1 pb-1 text-[11px] font-bold uppercase tracking-wide text-gray-400 sm:grid ${GRID}`}>
        <span>Patient</span>{MODES.map((m) => <span key={m.k} className="leading-tight">{m.l}</span>)}<span className="text-right">Total</span><span />
      </div>
      <div className="space-y-2">
        {rows.map((p, i) => (
          <div key={p.id} className={`grid grid-cols-3 gap-2 rounded-xl bg-gray-50 p-2 sm:bg-transparent sm:p-0 ${GRID}`} data-testid={`daily-patient-row-${i}`}>
            <div className="col-span-3 space-y-1 sm:col-span-1">
              <Input data-testid={`daily-patient-name-${i}`} value={p.patient} onChange={(e) => upd(i, "patient", e.target.value)} placeholder="NOM Prénom complets *" className="h-9 rounded-xl bg-white" />
              {(parseFloat(p.secu) > 0 || parseFloat(p.mutuelle) > 0) && p.patient.trim() && p.patient.trim().split(/\s+/).length < 2 && <p data-testid={`daily-patient-name-warn-${i}`} className="text-[11px] text-amber-700">Ajoutez le prénom pour le rapprochement Sécu / mutuelle</p>}
              {parseFloat(p.mutuelle) > 0 && <Input data-testid={`daily-patient-mutname-${i}`} value={p.mutuelle_name || ""} onChange={(e) => upd(i, "mutuelle_name", e.target.value)} placeholder="Nom mutuelle (facultatif)" className="h-8 rounded-xl bg-white text-xs" />}
            </div>
            {MODES.map((m) => (
              <div key={m.k}>
                <span className="text-[10px] font-semibold uppercase text-gray-400 sm:hidden">{m.l}</span>
                <Input data-testid={`daily-patient-${m.k}-${i}`} type="number" step="0.01" min="0" value={p[m.k]} onChange={(e) => upd(i, m.k, e.target.value)} placeholder="0" className="h-9 rounded-xl bg-white px-2" />
              </div>
            ))}
            <div className="flex items-end justify-end self-center text-sm font-bold text-[#065F46] sm:items-center">{fmtEUR2(rowTotal(p))}</div>
            <button type="button" data-testid={`daily-patient-remove-${i}`} onClick={() => onChange(rows.filter((_, j) => j !== i))} className="self-center justify-self-end rounded-lg p-1 text-gray-400 hover:bg-rose-50 hover:text-rose-600"><X className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <button type="button" data-testid="daily-patient-add" onClick={() => onChange([...rows, newPatient()])} className="mt-3 flex items-center gap-1 text-sm font-semibold text-[#065F46] hover:underline"><Plus className="h-4 w-4" />Ajouter un patient</button>
      {rows.length > 0 && (
        <div className={`mt-3 grid grid-cols-3 gap-2 border-t border-gray-100 pt-2 text-xs font-bold text-gray-600 ${GRID}`} data-testid="daily-patient-totals">
          <span className="col-span-3 sm:col-span-1">Total ({rows.length} patient{rows.length > 1 ? "s" : ""})</span>
          {MODES.map((m) => <span key={m.k}><span className="font-normal text-gray-400 sm:hidden">{m.l} </span>{fmtEUR2(sumMode(rows, m.k))}</span>)}
        </div>
      )}
    </div>
  );
}
